module.exports = __webpack_public_path__ + "static/media/Isologo.d3a685fe.png";